import { TBusinessAppointmentsState } from '../../types/businessAppointments';
import { IApplicationState } from '../../types/redux';

export function businessAppointmentsDataSelector(state: IApplicationState): TBusinessAppointmentsState['data'] {
  return state.businessAppointments.data;
}
